import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { formatRupiah, formatDate, todayWITA } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import DatePicker from "@/components/DatePicker";

export function TrancheRescheduleDialog({ schedule, tranche, onClose, onSaved }) {
  const open = (schedule.tranches || []).filter((t) => !t.cleared);
  const [tid, setTid] = useState(tranche?.id || open[0]?.id || "");
  const [date, setDate] = useState(tranche?.cair_date || "");
  const [reason, setReason] = useState("");
  const t = (schedule.tranches || []).find((x) => x.id === tid);
  const idx = (schedule.tranches || []).findIndex((x) => x.id === tid);
  useEffect(() => { if (t) setDate(t.cair_date); }, [tid]); // eslint-disable-line react-hooks/exhaustive-deps
  const minDate = (() => { const d = new Date(`${todayWITA()}T12:00:00`); d.setDate(d.getDate() + 1); return d.toISOString().slice(0, 10); })();

  const submit = async () => {
    if (!tid) return toast.error("Pilih termin BG");
    if (!reason) return toast.error("Isi alasan reschedule");
    if (!date) return toast.error("Pilih tanggal cair baru");
    try {
      await api.post("/change-requests", { type: "tranche_reschedule", schedule_id: schedule.id, tranche_id: tid, new_data: { cair_date: date }, reason });
      toast.success("Pengajuan reschedule termin dikirim, menunggu persetujuan owner");
      onSaved();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Reschedule {tranche ? `Termin BG ${idx + 1}` : "Termin BG"} · {schedule.code}</DialogTitle><DialogDescription className="sr-only">Pindahkan tanggal cair satu termin BG</DialogDescription></DialogHeader>
        <div className="space-y-3">
          {tranche ? (
            <div className="bg-slate-50 rounded p-2 text-xs" data-testid="tr-locked-info">
              <div className="font-semibold text-slate-900">BG {idx + 1} · {formatRupiah(tranche.amount)}</div>
              <div className="text-slate-500">{tranche.method === "giro" ? `Giro ${tranche.warkat_number || "-"} · ${tranche.warkat_bank || "-"}` : "Transfer"} · cair {formatDate(tranche.cair_date)}</div>
            </div>
          ) : (
            <div className="space-y-1.5">
              <Label className="text-xs">Pilih Termin (BG belum cair)</Label>
              <Select value={tid} onValueChange={setTid}>
                <SelectTrigger data-testid="tr-select"><SelectValue placeholder="Pilih termin" /></SelectTrigger>
                <SelectContent>
                  {open.map((x) => (
                    <SelectItem key={x.id} value={x.id}>
                      {`BG ${x.warkat_number || (x.method === "giro" ? "Giro" : "Transfer")} · ${formatRupiah(x.amount)} · ${formatDate(x.cair_date)}`}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {open.length === 0 && <div className="text-xs text-rose-600">Semua termin sudah cair.</div>}
            </div>
          )}
          {t && !tranche && <div className="text-xs text-slate-500">Tanggal cair saat ini: {formatDate(t.cair_date)}</div>}
          <div className="space-y-1.5"><Label className="text-xs">Tanggal Cair Baru</Label><DatePicker value={date} today={todayWITA()} minDate={minDate} onChange={setDate} testid="tr-date-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Alasan</Label><Textarea value={reason} onChange={(e) => setReason(e.target.value)} data-testid="tr-reason-input" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Batal</Button><Button onClick={submit} disabled={open.length === 0} data-testid="tr-submit-btn">Ajukan</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
